import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizationPipe } from './localization.pipe';

@Pipe({ name: 'statusTag', pure: false })
export class StatusTagPipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => LocalizationPipe)) private localizationPipe: LocalizationPipe
    ) { }

    transform(label: string, args: StatusTagPipeBody): string {
        label = this.localizationPipe.transform(label);
        let style = `padding: ${args?.icon ? '4px 0px 4px 6px' : '4px 6px'};`;
        if (args?.color) {
            style += `color:${args.color};`;
        }
        if (args?.backgroundColor) {
            style += `background-color:${args.backgroundColor};`;
        }
        let result = `<div class="d-flex status-tag-value" style="${style}">`;
        result += `<span>${label}</span>`;
        if (args?.icon) {
            result += `<span class="material-symbols-outlined filled-icon action-state-icon" style="${args.iconStyle}">${args.icon}</span>`;
        }
        result += '</div>';
        return result;
    }
}

export class StatusTagPipeBody {
    icon: string;
    iconStyle: string;
    color: string;
    backgroundColor: string;
}

